import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import { PulseLoader } from "react-spinners";
import { disableAgentAsync } from "../../../../redux/features/adminSlice";
import { toast } from "react-toastify";

interface DisableAgentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  agentId: string;
}

const DisableAgentModal: React.FC<DisableAgentModalProps> = ({
  isOpen,
  onClose,
  agentId,
  onConfirm,
}) => {
  const { isLoading } = useAppSelector((state) => state.admin);
  const dispatch = useAppDispatch();

  const handleSubmit = () => {
    dispatch(disableAgentAsync(agentId))
      .unwrap()
      .then(() => {
        toast.success("Agent disabled successfully");
        onClose();
        onConfirm();
      });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-full max-w-md rounded-lg p-6 shadow-lg">
        {/* Icon Section */}
        <div className="flex justify-center mb-4">
          <div className="bg-red-100 text-red-500 rounded-full p-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-8 h-8"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 11c1.657 0 3-1.343 3-3S13.657 5 12 5s-3 1.343-3 3 1.343 3 3 3zm0 4c-2.667 0-8 1.333-8 4v2h16v-2c0-2.667-5.333-4-8-4z"
              />
            </svg>
          </div>
        </div>

        {/* Title Section */}
        <h2 className="text-center text-xl font-semibold mb-2">
          Disable This Agent
        </h2>

        {/* Description Section */}
        <p className="text-center text-gray-600 mb-6">
          Are you sure you want to disable this agent?
        </p>

        {/* Action Buttons */}
        <div className="flex justify-between">
          <button
            onClick={onClose}
            className="w-1/2 bg-gray-100 text-gray-800 rounded-md py-2 px-4 mr-2 hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="w-1/2 bg-red-500 text-white rounded-md py-2 px-4 hover:bg-red-600"
          >
            {isLoading ? (
              <PulseLoader color="#fff" size={10} />
            ) : (
              "Yes, Disable"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisableAgentModal;
